// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"bankAccount_buttonWrapper__aNvgB","accountItem":"bankAccount_accountItem__inmKm","account":"bankAccount_account__JG4DD"};